<script>
  import SelectMode from './SelectMode.svelte'
  import SelectAttribute from './SelectAttribute.svelte'
  import Octicon from 'components/primer/Octicon.svelte'

  import { createEventDispatcher } from 'svelte'

  export let title = 'Layer'
  export let layer = undefined
  const dispatch = createEventDispatcher()

  const remove = () => {
    dispatch('delete')
  }
</script>

<style>

</style>

<li class="Box-row">
  <div class=" d-flex flex-row flex-items-center">
    <div class="flex-auto">
      <h5 class="h5">{title}</h5>
    </div>
    <SelectMode bind:mode={layer.mode} />
  </div>
  <SelectAttribute bind:attribute={layer.attribute} />

  <div class="d-flex flex-row-reverse">
    <button
      type="button"
      class="btn-link text-small text-gray-light"
      title="Remove the layer"
      on:click|preventDefault={remove}>
      <Octicon symbol="trashcan" ariaLabel="Remove" />
    </button>
  </div>
</li>
